import { post, get, put, del } from "./methods"
// import { Page } from "@/interface/common"
import { GraceList, GraceDetail } from "@/interface/grace"
export const upload = (params: any) => post('/api/mr/upload/r', params)
export const style = (params: any) => post('/api/mr/material/style', params)
export const getGraceList = (params: any) => get<GraceList>(`/api/mr/styles/${params.pageNum}/${params.pageSize}`)
export const star = (params: any) => put(`/api/mr/material/style/${params.id}/${params.like}`)
export const getGraceDetail = (params: any) => get<GraceDetail>(`/api/mr/style/${params.id}`)
export const deleteGrace = (params: any) => del(`/api/mr/material/style/${params.id}`)
export const editGrace = (params: any) => put('/api/mr/material/style', params)
export const uploadPercent = (params?: any) => get(`/api/mr/upload/percent`, params);
export const resetUploadPercent = (params?: any) => post(`/api/mr/upload/resetPercent`, params)